import Tippy, { useSingleton } from "@tippyjs/react";
import { useAtomValue } from "jotai";
import { canv } from "@/canv/global";
import { HandIcon, HelpIcon } from "@/icons";
import { MiniMapButton } from "@/interface/BottomBar/BottomRightBar/MiniMap/MiniMapButton";
import { Tooltip } from "@/interface/ui/Tooltip";
import {
    activeVoteVisibilityAtom,
    currentToolAtom,
    startVoteActiveTabAtom,
    startVoteVisibilityAtom,
} from "../../AppStore";
import styles from "./BottomBar.module.css";
import { BottomBarItem } from "./BottomBarItem";
import { BottomBarSearch } from "./BottomBarSearch";
import { ZoomControls } from "./ZoomControls";

const HELP_LINK = "https://help.mts-link.ru/category/4162";
const WRAPPER_ID = "bottom-bar-wrapper-react";

export const BottomRightBar = () => {
    const currentTool = useAtomValue(currentToolAtom);
    const isActiveVoteVisible = useAtomValue(activeVoteVisibilityAtom);
    const isStartVoteVisible = useAtomValue(startVoteVisibilityAtom);
    const startVoteActiveTab = useAtomValue(startVoteActiveTabAtom);

    const isDragToolButtonVisible =
        !isActiveVoteVisible && !(isStartVoteVisible && startVoteActiveTab === "new");

    const [source, target] = useSingleton();
    return (
        <div className={styles.wrapper} id={WRAPPER_ID}>
            <div className={styles.bottomBar}>
                <Tippy singleton={source} />
                {isDragToolButtonVisible && (
                    <Tooltip
                        content={isDragToolButtonVisible ? "Перемещение" : undefined}
                        hotkey="H"
                        singleton={target}
                        disabled={!isDragToolButtonVisible}
                        key={String(isDragToolButtonVisible)}
                    >
                        <BottomBarItem
                            active={currentTool.name === "dragTool"}
                            onClick={() => {
                                canv.toolBox.switchToByName("dragTool");
                            }}
                        >
                            <HandIcon />
                        </BottomBarItem>
                    </Tooltip>
                )}
                <ZoomControls singletonTarget={target} />
                <MiniMapButton singletonTarget={target} />
                <BottomBarSearch singletonTarget={target} />
                <Tooltip content="Помощь" singleton={target}>
                    <BottomBarItem as="a" href={HELP_LINK} target="_blank">
                        <HelpIcon />
                    </BottomBarItem>
                </Tooltip>
            </div>
        </div>
    );
};
